"use strict";

var _ = require("underscore");

var navigateKeys = {
  UP: 38,
  DOWN: 40,
  ENTER: 13,
  ESC: 27,
  ALL_KEYS: [38, 40, 13, 27]
};

/*
 * Dependencies:
 * The component should have a keyNavigate method
 */

module.exports.mixin = {
  onKeyDown: function(e){
    var isNavigateKey = (navigateKeys.ALL_KEYS.indexOf(e.keyCode) != -1);
    if (isNavigateKey) {
      e.preventDefault();
      this.keyNavigate(e.keyCode);
    }
  },
  componentDidMount: function () {
    if (typeof this.keyNavigate != "function") {
      throw new Error("KeyNavigatorMixin - required method keyNavigate is missing in the component using the mixin");
    }
  }
};



// it depends on the store having a focusedIndex and focusId state attributes
module.exports.storeMixin = {
  init: function() {
    //this.intervals = [];
    if (typeof this.state.focusIndex != "number") {
      throw new Error("KeyNavigatorStoreMixin - required state attribute focusIndex is missing or is not a number");
    }
    if (typeof this.state.focusId != "number") {
      throw new Error("KeyNavigatorStoreMixin - required state attribute focusId is missing or is not a number");
    }
  },
  navigate: function(keyCode, list){
    if (keyCode == navigateKeys.DOWN) {
      this.navigateDown(list);
    } else if (keyCode == navigateKeys.UP) {
      this.navigateUp(list);
    } else if (keyCode == navigateKeys.ENTER) {
      this.onEnterPressed(list);
    } else if (keyCode == navigateKeys.ESC) {
      this.onEscPressed(list);
    }
  },
  navigateDown: function (list) {
    // elements in list should have an attribute id

    var focusIndex = this.state.focusIndex;
    if (focusIndex + 1 >= list.length) {
      focusIndex = -1;
    } else {
      focusIndex++;
    }

    this.focusItem(list, focusIndex);
    this.trigger(this.state);
  },
  navigateUp: function (list) {
    var focusIndex = this.state.focusIndex;

    if (focusIndex - 1 == -2) {
      focusIndex = list.length-1;
    } else if (focusIndex - 1 == -1) {
      focusIndex = -1;
    } else {
      focusIndex--;
    }

    this.focusItem(list, focusIndex);
    this.trigger(this.state);
  },
  onEnterPressed: function (list) {
    if (typeof this.enterPressed == "function") {
      this.enterPressed(this.findElementByID(list, this.state.focusId));
    }
  },
  onEscPressed: function (list) {
    if (typeof this.escPressed == "function") {
      this.escPressed(this.findElementByID(list, this.state.focusId));
    }
  },
  focusItem: function (list, index) {
    this.state.focusIndex = index;
    this.state.focusId = (list[index])?list[index].id:null;
  },
  findElementByID: function (list, id) {
    return _.find(list, function(u){
      return u.id == id;
    });
  }
};


// WEBPACK FOOTER //
// ./app/util/browser/key-navigator.js